import { createReducer, on } from '@ngrx/store';

import * as InstitutionProgramActions from './institution-program.actions';
import * as InstitutionActions from '../institution/institution.actions';
import {
  institutionProgramStateAdapter,
  initialInstitutionProgramState
} from './institution-program.state';

export const reducer = createReducer(
  initialInstitutionProgramState,
  on(
    InstitutionProgramActions.updateProgramsForInstitutionOptions,
    (state, { options }) => ({
      ...state,
      programsForInstitutionOptions: {
        ...state.programsForInstitutionOptions,
        ...options
      }
    })
  ),
  on(InstitutionProgramActions.clearProgramsForInstitutionOptions, (state) => ({
    ...state,
    programsForInstitutionOptions: {
      ...initialInstitutionProgramState.programsForInstitutionOptions
    }
  })),
  on(InstitutionProgramActions.loadInstitutionPrograms, (state) => ({
    ...state,
    programsForInstitutionOptions: {
      ...state.programsForInstitutionOptions,
      skip: 0
    }
  })),
  on(
    InstitutionProgramActions.loadInstitutionProgramsSuccess,
    (state, { institutionPrograms }) =>
      institutionProgramStateAdapter.setAll(institutionPrograms, state)
  ),
  on(
    InstitutionProgramActions.loadInstitutionProgramsFailure,
    (state, { error }) => ({ ...state, error })
  ),
);
